import { useCallback, useMemo } from "react";

import { useApi } from "shared/services/api/useApi";

export const useUser = () => {
    const { getDataAsync } = useApi();

    const getUserDetail = useCallback(async (urlParams) => {
        const payload = await getDataAsync("userDetail", { urlParams: urlParams });
        return payload.json();
    }, [getDataAsync]);

    const getEmployeesForSearch = useCallback(async () => {
        const payload = await getDataAsync("getEmployeesForSearch");
        return payload.json();
    }, [getDataAsync]);

    return useMemo(() => {
        return {
            getUserDetail,
            getEmployeesForSearch,
        };
    }, [getUserDetail, getEmployeesForSearch]);
};
